import React from 'react';

import styles from './modal.module.css';

function TopicDelete(props) {
    return <div className={styles.modalWrapper}>
        <div className={styles.modalContent}>
            <h4 className={styles.modalTitle}>
                Topicsを削除
            </h4>
            <p style={{paddingTop: 25}}>このTopicsを削除します。本当によろしいですか？</p>
            <div style={{paddingTop: 15, paddingBottom: 10}}>
                <label>タイトル : </label>
                <span>{props.item.title}</span>
            </div>
            <div className={styles.footerTopic}>
                <button className={styles.buttonModal} onClick={props.onClose}>キャンセル</button>
                <button className={styles.buttonModal} onClick={props.onSave}>削除</button>
            </div>
        </div>
    </div>
}

export default TopicDelete;